import { myArtistXP, artists } from "@/mocks/artistData";
import { Link } from "react-router-dom";

export default function MyArtistXP() {
  return (
    <div>
      <h3 className="text-white font-bold text-base mb-4 flex items-center gap-2">
        <i className="ri-star-line text-[#ffd60a]" />
        아티스트별 XP
      </h3>
      <div className="flex flex-col gap-3">
        {myArtistXP.map((axp) => {
          const artist = artists.find((a) => a.id === axp.artistId);
          if (!artist) return null;
          const pct = Math.min(100, Math.round((axp.xp / axp.nextLevelXP) * 100));
          return (
            <Link
              to={`/rewards/${axp.artistId}`}
              key={axp.artistId}
              className="flex items-center gap-4 p-4 rounded-xl border border-white/8 bg-white/[0.02] hover:border-white/15 hover:bg-white/[0.04] transition-all cursor-pointer group"
            >
              {/* Avatar */}
              <div className="w-11 h-11 rounded-xl overflow-hidden flex-shrink-0">
                <img src={artist.avatar} alt={artist.name} className="w-full h-full object-cover object-top" />
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1.5">
                  <div>
                    <span className="text-white font-semibold text-sm">{artist.name}</span>
                    <span className="text-white/30 text-xs ml-2">{axp.levelName}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-[#ffd60a] text-xs" />
                    <span className="font-bold text-sm" style={{ color: artist.accentColor }}>
                      {axp.xp.toLocaleString()}
                    </span>
                    <span className="text-white/25 text-xs">XP</span>
                  </div>
                </div>
                <div className="h-1.5 rounded-full bg-white/8 overflow-hidden">
                  <div
                    className="h-full rounded-full transition-all duration-700"
                    style={{ width: `${pct}%`, background: `linear-gradient(90deg, ${artist.accentColor}, ${artist.secondaryColor || artist.accentColor})` }}
                  />
                </div>
                <div className="flex justify-between mt-1">
                  <span className="text-white/25 text-[10px]">Lv.{axp.level}</span>
                  <span className="text-white/25 text-[10px]">{axp.nextLevelXP.toLocaleString()} XP까지</span>
                </div>
              </div>

              <div className="w-5 h-5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0">
                <i className="ri-arrow-right-s-line text-white/40" />
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
